<app-subsection-title key="provider.tender.confirmation.title" />

<form [formGroup]="decisionForm" class="space-y-6">
  <div class="space-y-4">
    <div class="flex items-start gap-3">
      <p-radioButton
        name="decision"
        value="accept"
        [formControl]="decisionControl"
        inputId="accept"
      />
      <label for="accept" class="text-sm cursor-pointer">
        {{ dynamicAcceptText() | transloco }}
      </label>
    </div>

    <div class="flex items-start gap-3">
      <p-radioButton
        name="decision"
        value="decline"
        [formControl]="decisionControl"
        inputId="decline"
      />
      <label for="decline" class="text-sm cursor-pointer">
        {{ dynamicDeclineText() | transloco }}
      </label>
    </div>
  </div>

  <div class="text-(--color-red) text-sm">
    {{ 'provider.tender.confirmation.deadline' | transloco }}:
    <strong>{{ submissionDate() | appDate }}</strong>
  </div>

  @if (!isAccepting()) {
    <app-tender-rejection-reason />
  }

  <div class="flex justify-end gap-3 mt-6">
    @if (isAccepting()) {
      <p-button
        [label]="acceptButtonKey() | transloco"
        data-testid="accept-button"
        (onClick)="acceptTender()"
      />
    } @else if (hasRejectionReason()) {
      <p-button
        [label]="'provider.tender.confirmation.declineButton' | transloco"
        data-testid="reject-button"
        (onClick)="rejectTender()"
      />
    }
  </div>
</form>
